/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-external-order-shipment-item.reducer';

export const PharmacyExternalOrderShipmentItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyExternalOrderShipmentItemEntity = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyExternalOrderShipmentItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.detail.title">
            PharmacyExternalOrderShipmentItem
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.id}</dd>
          <dt>
            <span id="shippedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shippedQty">Shipped Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.shippedQty}</dd>
          <dt>
            <span id="receivedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.receivedQty">Received Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.receivedQty}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.packs}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.productType}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.productId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.timestampEntry}</dd>
          <dt>
            <span id="purchaseBillItemId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.purchaseBillItemId">
                Purchase Bill Item Id
              </Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.purchaseBillItemId}</dd>
          <dt>
            <span id="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.freeQty">Free Qty</Translate>
            </span>
            <UncontrolledTooltip target="freeQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.help.freeQty" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.freeQty}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.orderItem">Order Item</Translate>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.orderItem ? pharmacyExternalOrderShipmentItemEntity.orderItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shipment">Shipment</Translate>
          </dt>
          <dd>{pharmacyExternalOrderShipmentItemEntity.shipment ? pharmacyExternalOrderShipmentItemEntity.shipment.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-external-order-shipment-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/pharmacy-external-order-shipment-item/${pharmacyExternalOrderShipmentItemEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyExternalOrderShipmentItemDetail;
